import { ViewController, PagerView, Matchday, ModelUpdateEvent, DataReceiveEvent, SelectionUpdateEvent,
         TimeoutEvent, OddsGalleryView, OddsGalleryViewDelegate } from "@gaming/srvg-classes-core";

// Uses srvg.server, srvg.oddsComponents, srvg.featuresInstances, srvg.productName

export class OddsViewController extends ViewController implements OddsGalleryViewDelegate {
    public oddsView:OddsGalleryView;
    public pagerView:PagerView;
    public betmarket:string;

    private matchday:Matchday;
    private comboOdds:any;
    private oddsData:any;

    constructor(options) {
        super( options );
        options = options || {};
        options.view = options.oddsView || null;
        this.view = options.view;
        this.name = 'oddsViewController';

        srvg.oddsComponents = srvg.oddsComponents || [];

        this.oddsView = options.view || null;
        this.pagerView = options.pagerView || null;

        this.betmarket = options.betmarket || '';

        this.matchday = null;
        this.comboOdds = null;
        this.oddsData = null;

        this.oddsView.setDelegate( this );
    }

    calculateComboOdds() {
        var comboOdds = [];

        // initialize combos with empty arrays
        srvg.oddsComponents.forEach(function (oddsComponent) {
            comboOdds[oddsComponent.name] = []
        });

        // add odds to their combos
        var seasonid = this.matchday.getSeason().id;
        var matchday = this.matchday.nr;
        for (var match in this.oddsData[seasonid][matchday]) {
            for (var team in this.oddsData[seasonid][matchday][match]) {
                var oddsentry = this.oddsData[seasonid][matchday][match][team][this.betmarket];
                srvg.oddsComponents.forEach(function (oddsComponent) {
                    if (oddsentry && oddsentry.combos[oddsComponent.name]) {
                        oddsentry.matchId = match; // this will be needed later
                        oddsentry.unified.uf_match_id = srvg.config.unifiedPrefixes.match + match; // Add uf match id to unified object
                        comboOdds[oddsComponent.name].push(oddsentry);
                    }
                });
            }
        }
        return comboOdds;
    }

    handleDataReceiveEvent(event: DataReceiveEvent, provider) {
        if( this.matchday && this.matchday.getSeason() && ( ! event.data || ! event.data.odds || ! event.data.odds[this.matchday.getSeason().id] || ! event.data.odds[this.matchday.getSeason().id][this.matchday.nr] ) ) {
            // if data received is not for the selected matchday, ignore data // (VBL-453)
            return;
        }
        this.oddsData = event.data.odds;

        if (this.matchday) {
            var now = app.server.getTime();
            if (this.matchday.betstop() > now) { // TODO
                this.comboOdds = this.calculateComboOdds();
                this.configureTicker();
            }
            /*
            // not necessary, because of duplicated call here
            else {
                this.oddsView.stopAnimation();
                this.oddsView.setItems([]);
                if (this.pagerView) {
                    this.pagerView.setLength(0);
                }
            }*/
        }
    }

    handleModelUpdateEvent(event:ModelUpdateEvent, provider) {
        if( event.propertyName == 'selectedMatchday' ) {
            var newMatchday = event.propertyValue;
            if (!this.matchday || ! this.matchday.getSeason() || this.matchday.getSeason().id != newMatchday.getSeason().id || this.matchday.nr != newMatchday.nr) {
                this.matchday = newMatchday; // FIXME does this really need to store the matchday?

                if (this.matchday && this.oddsData && (!this.oddsData[this.matchday.getSeason().id] || !this.oddsData[this.matchday.getSeason().id][this.matchday.nr] ) ) {
                    this.oddsData = null;
                }

                if (this.oddsData) {
                    var now = app.server.getTime();
                    if (this.matchday.betstop() > now) {
                        this.comboOdds = this.calculateComboOdds();
                        this.configureTicker();
                    }
                    else {
                        this.oddsView.stopAnimation();
                        this.oddsView.setItems([]);
                        if (this.pagerView) {
                            this.pagerView.setLength(0);
                        }
                    }
                }
                else {
                    this.oddsView.stopAnimation();
                    this.oddsView.setItems([]);
                    if (this.pagerView) {
                        this.pagerView.setLength(0);
                    }
                    var now = app.server.getTime();
                    if (this.matchday.betstop() > now) {
                        $(this.oddsView.selector).show();

                        if( ! srvg.featuresInstances.getDisableOdds() ) {
                            // Add loader gfx
                            $(this.oddsView.selector).append($('<div class="loader"></div>'));
                            var that = this;
                            window.setTimeout( function() {
                                // Hide loader after 10 secs
                                $(that.oddsView.selector + ' .loader').hide();
                            }, 10000 );
                        }
                    }
                }
            }
        }
    }

    private multiplyComboOdds() {
        var maxOdds = srvg.featuresInstances.getMaxOdds();
        var that = this;

        var items = [];

        // add each combo odd to ticker
        srvg.oddsComponents.forEach(function (oddsComponent) {
            var zero = new Decimal(0);
            var odd = new Decimal(0);

            var oddsParameter = [];

            that.comboOdds[oddsComponent.name].forEach(function (oddsEntry) {
                if (odd.equals( zero )) {
                    odd = new Decimal(oddsEntry.odd);
                }
                else {
                    // multiply odds to get combo odd
                    odd = odd.times( oddsEntry.odd );
                }

                oddsParameter.push({
                    oddsId: oddsEntry.oid,
                    oddsFieldType: oddsEntry.fname,
                    type: that.betmarket,
                    validateValue: oddsEntry.odd,
                    matchId: oddsEntry.matchId,
                    identify: srvg.product.name,
                    unified: oddsEntry.unified
                });
            });
            if (maxOdds && odd.toNumber() > maxOdds) {
                // combo odds are too large
                return;
            }
            if (odd.toNumber() != 0) {
                items.push({
                    name: oddsComponent.name,
                    odd: odd.toFixed(2),
                    oddsData: oddsParameter
                });
            }
        });

        return items;
    }

    private configureTicker() {
        var items = this.multiplyComboOdds();

        this.oddsView.stopAnimation();
        this.oddsView.setItems(items);
        if (this.pagerView) {
            var numPages = Math.ceil( items.length / this.oddsView.numberOfItemsToShow );
            this.pagerView.setLength(numPages);
        }
        this.oddsView.startAnimation();
    }

    handleTimeoutEvent(event:TimeoutEvent, provider) {
        if( provider == app.inactivityController ) {
            // idle timeout
            this.oddsView.deactivate();
        }
        else {
            // countdown finished
            this.oddsView.stopAnimation();
        }
    }

    handleSelectPageEvent = function (event, provider) {
        this.oddsView.stopAnimation();
        this.oddsView.setIndex(event.page * this.oddsView.numberOfItemsToShow);
        this.oddsView.startAnimation();
    }

    handleSelectionUpdateEvent( event: SelectionUpdateEvent, provider: OddsGalleryView ) {
        if (this.pagerView) {
            // FIXME this.pagerView.selectIndex(Math.floor(event.index / this.oddsView.numberOfItemsToShow));
        }
    }
}